import React from 'react';
import styled from '@emotion/styled'
import * as styleConfig from '../../styles/config.module.scss';
import * as breakpoint from '../../styles/breakpoints.module.scss';

const CommonSection = (props) => {

  let { children , bgColor } = props;
 
  return(
   <SectionWrapper bgColor={bgColor} {...props}>
     <SectionContent>{children}</SectionContent>
   </SectionWrapper>
  );

}



const SectionWrapper = styled.div`
  background: ${props => props.bgColor ? props.bgColor : '#F7F7FA'};
`;

const SectionContent = styled.div`
  width:100%;
  max-width: calc(${styleConfig.layoutWidthXL} + 96px);
  margin:0 auto;
  padding:96px 48px;
  display:flex;
  align-items:center;
  flex-wrap:wrap;

  @media only screen and (max-width: ${breakpoint.smMax}){
    padding:64px 80px;
  }
  @media only screen and (max-width: ${breakpoint.xsMax}){
    padding:32px 24px;
  }
`;

const SectionRow = styled.div`
  display:flex;
  width: ${styleConfig.layoutContentWidthXL};
  margin:0 auto;
  @media only screen and (max-width: ${breakpoint.smMax}){
    width:calc(100% + 16px);
    flex-wrap:wrap;
  }
`

const SectionFullWidthColumn = styled.div`
  width:100%;
  //padding-left: calc(${styleConfig.layoutWidthXL} /2 - ${styleConfig.layoutContentWidthXL} / 2);
  //padding-right: calc(${styleConfig.layoutWidthXL} /2 - ${styleConfig.layoutContentWidthXL} / 2);
  max-width:${styleConfig.layoutContentWidthXL};
  margin:0 auto;

  @media only screen and (max-width: ${breakpoint.smMax}){
    padding:0;
  }
`

const SectionTextColumn = styled.div`
  width:50%;
  &:nth-of-type(odd){
    padding-left: calc(50% - ${styleConfig.layoutContentWidthXL} / 2);
    padding-right:32px;
  }

  &:nth-of-type(even){
    padding-left:32px;
    padding-right: calc(50% - ${styleConfig.layoutContentWidthXL} / 2);
  }

  @media only screen and (max-width: ${breakpoint.smMax}){
    width:100%;
    &:nth-of-type(odd), &:nth-of-type(even){
      padding:0 0 38px;
    }
  }
`
const SectionImageColumn = styled.div`
  width:50%;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  border-radius: 6px;
  z-index:1;
  overflow:hidden;

  @media only screen and (max-width: ${breakpoint.smMax}){
    width:100%;
    padding:0;
  }
`

const MarkdownContainer = styled.div`

  h2{
    font-size: 36px;
    line-height: 48px;
    letter-spacing: 0.03em;
    font-feature-settings: 'palt' on;
    margin:172px 0 24px;
    color:#2C2C2E;

    &:first-of-type{
      margin-top:0;
    }

    @media only screen and (max-width: ${breakpoint.smMax}){
      font-size: 36px;
      line-height: 48px;
      margin:128px 0 24px;
    }
    @media only screen and (max-width: ${breakpoint.xsMax}){
      font-size: 24px;
      line-height: 32px;
      margin:64px 0 16px;
    }
  }

  p{
    font-size: 16px;
    line-height: 150%;
    color: #444448;

    @media only screen and (max-width: ${breakpoint.xsMax}){
      font-size: 14px;
    }
  }


  a{
    margin-bottom:24px;
    color: #D00F31;
    font-size: 16px;
    line-height: 150%;
    @media only screen and (max-width: ${breakpoint.xsMax}){
      font-size: 13px;
    }
  }
`


export default CommonSection;
export {
  SectionTextColumn,
  SectionImageColumn,
  SectionFullWidthColumn,
  SectionRow,
  MarkdownContainer
}
